import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, DollarSignIcon, FrownIcon } from 'lucide-react';
import { IMAGES } from '../data/landing';
const puntos = [{
  icon: ClockIcon,
  texto: 'Prender el horno, esperar 40 minutos y después lavar todo te saca las ganas.'
}, {
  icon: DollarSignIcon,
  texto: 'Terminás pidiendo empanadas por $15.000 o comiendo un sándwich triste.'
}, {
  icon: FrownIcon,
  texto: 'Tu freidora está ahí mirándote, pero solo la usás para calentar sobras.'
}];
export function PainSection() {
  return <section className="w-full bg-neutral-100 py-10 sm:py-16" data-id="element-150" data-mp="2q0nb92viu6nd">
      <div className="mx-auto grid max-w-6xl items-center gap-10 px-4 sm:px-6 lg:grid-cols-2" data-id="element-151" data-mp="2baxvo2mom03k">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-152" data-mp="2g8pw5l1e6ujd">
          <h2 className="text-2xl font-black leading-tight text-neutral-900 sm:text-3xl lg:text-4xl" data-id="element-153" data-mp="277jidjq4nxtt">
            Llegás a las 7 de la tarde, tenés hambre… y de nuevo la misma historia.
          </h2>
          <p className="mt-5 text-base leading-relaxed text-neutral-600 sm:text-lg" data-id="element-154" data-mp="3nknooxl7wyax">
            Laburaste todo el día. Lo último que querés es una producción en la cocina.
            Así que la comida rica queda para "otro día" que nunca llega.
          </p>

          <ul className="mt-6 space-y-4" data-id="element-155" data-mp="38w9o6tb9xlxj">
            {puntos.map(({
            icon: Icon,
            texto
          }, i) => <li key={i} className="flex items-start gap-3" data-id="element-156" data-mp="33y7u7dcb827a" data-mpi={i}>
                <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-600" data-id="element-157" data-mp="33vlnffx8tqq4">
                  <Icon className="h-5 w-5" data-id="element-158" data-mp="3dv485ykz9gj8" />
                </span>
                <span className="text-base text-neutral-800" data-id="element-159" data-mp="3dtt0hnoevomu">{texto}</span>
              </li>)}
          </ul>

          <p className="mt-7 rounded-xl border-l-4 border-yellow-500 bg-white p-4 text-base font-semibold text-neutral-900 shadow-sm" data-id="element-160" data-mp="2l6yiqyizb3d2">
            Es hora de que esa máquina empiece a pagar su inversión.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="overflow-hidden rounded-3xl shadow-xl" data-id="element-161" data-mp="u1vdwdsi74j9">
          <img src={IMAGES.milanesa} alt="Milanesa crocante hecha en Air Fryer con limón y ensalada" className="h-full w-full object-cover" data-id="element-162" data-mp="65hhrw11pb6x" />
        </motion.div>
      </div>
    </section>;
}